import brand from '@helpers/brand';
import { baseGrid } from '@helpers/grid';
import { Device, from, until } from '@helpers/media';
import BurnEffect from '@img/burn-effect.png';
import styled from 'styled-components';
const Container = styled.section `
  position: relative;
  display: block;
`;
const Grid = styled.div `
  ${baseGrid};
  position: relative;
  z-index: 2;

  @media ${until(Device.Tablet)} {
    row-gap: 32px;
  }
`;
const ContentArea = styled.div `
  grid-column: span 12;
  grid-row: 1;

  @media ${from(Device.Tablet)} {
    grid-column: span 6;
  }

  [data-media-alignment='left'] & {
    @media ${from(Device.Tablet)} {
      grid-column: 7 / span 6;
    }
  }

  [data-media-alignment='none'] & {
    @media ${from(Device.Tablet)} {
      grid-column: 4 / span 6;
    }
  }
`;
const MediaArea = styled.div `
  grid-column: span 12;
  grid-row: 2;
  display: grid;
  align-items: start;
  height: 100%;

  @media ${from(Device.Tablet)} {
    grid-column: 7 / span 6;
    justify-content: end;
    grid-row: 1;
  }

  [data-media-alignment='left'] & {
    @media ${from(Device.Tablet)} {
      grid-column: span 6;
    }
  }

  [data-media-alignment='none'] & {
    display: none;
  }
`;
const MediaHolder = styled.div `
  position: sticky;
  top: 100px;
`;
const Media = styled.div `
  overflow: hidden;
  border-radius: 16px;
  position: relative;
`;
const Image = styled.img `
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
`;
export const BurnOverlay = styled.div `
  width: 152%;
  height: 150%;
  background-image: url(${BurnEffect});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: absolute;
  top: 50%;
  left: 0;
  transform: translate(-3%, -50%);
  mix-blend-mode: lighten;
`;
const ShapeShadow = styled.div `
  position: absolute;
  background-color: ${brand.buff.buff3};
  width: 100%;
  height: 100%;
  transform: translate(10px, 10px);
  border-radius: 16px;

  @media ${from(Device.Tablet)} {
    transform: translate(20px, 20px);
  }

  [data-media-alignment='left'] & {
    transform: translate(10px, 10px);

    @media ${from(Device.Tablet)} {
      transform: translate(-20px, 20px);
    }
  }
`;
const ContentAccordionStyles = {
    BurnOverlay,
    Container,
    ContentArea,
    Grid,
    Image,
    Media,
    MediaArea,
    MediaHolder,
    ShapeShadow,
};
export default ContentAccordionStyles;
